import { apiHandler } from "../buyerApiHandler";

export const createPublicNotification = (payload: {
  title: string;
  message: string;
  type: "system" | "promotion";
  image_url: string;
  data: {
    maintenance_date?: string;
    start_time?: string;
    end_time?: string;
    coupon_code?: string;
    discount?: number;
    url?: string;
  };
}) => {
  return apiHandler("post", `/api/buyer/broadcast-notification`, payload, {
    headers: { "Content-Type": "application/json" },
  });
};